module.exports = __webpack_public_path__ + "static/media/IconHexagonGreen.966d2f0a.svg";